import { type StructuredText as StructuredTextType } from 'datocms-structured-text-utils'
import { graphql } from 'gatsby'
import React from 'react'

import StructuredTextDefault from '@/components/structured-text/structured-text-default'

const Content: React.FC<Queries.SectionContentFragment> = ({
  content,
  display
}) => {
  return (
    <div className={`col-lg-${display} col-no-image`}>
      <div className="pe-lg-4">
        <StructuredTextDefault
          content={content as unknown as StructuredTextType}
        />
      </div>
    </div>
  )
}

export default Content

export const query = graphql`
  fragment SectionContent on DatoCmsContent {
    __typename
    id
    display
    content {
      value
      links
      blocks {
        __typename
        ... on DatoCmsImage {
          ...ImageInline
        }
        ... on DatoCmsVideo {
          ...VideoInline
        }
        ... on DatoCmsEmbed {
          ...EmbedInline
        }
        ... on DatoCmsCta {
          # All Blocks insert in a structured text needs to alias originalId to id
          id: originalId
          ...Cta
        }
      }
    }
  }
`
